import { Datagrid, DateField, List, NumberField, ReferenceField, TextField, useRecordContext } from 'react-admin';
import { url_image } from '../constant/constant';
import { DateInput, getStringFromDate, MaterialUIPickers } from '../constant/DateInput';

const CustomImageField = ({ source, width, marginTop }) => {
    const record = useRecordContext();
    // console.log("record", record);
    // console.log("record source", record[source]);
    return (<img src={url_image+record[source]} width={width} style={{marginTop: marginTop}} />);
};

const CustomNumberField = ({ source }) => {
    const record = useRecordContext();
    // console.log("record", record);
    // console.log("record source", record[source]);
    return (<span style={{color: record[source]<=3? "red":"black" }}>{record[source]}</span>);
};

const reportFilters = [
    <DateInput source="created_at" 
        // views={["year", "month"]} 
        parse={val => getStringFromDate(val).substring(0,10) }
        inputFormat="dd MMMM yyyy"
        // alwaysOn 
        label="Tanggal Layanan"
    />,
];

export const PenilaianList = () => (
    <List filters={reportFilters} sort={{ field: 'created_at', order: 'DESC' }} >
        <div>
            <div style={{width: "100%", backgroundColor: "white", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", marginBottom: 20}}>
                <h3 style={{margin: 5}}>Report Survey Kepuasan Pelayanan</h3>
                <h3 style={{margin: 5}}>(Poin 1 = Sangat Tidak Puas, 6 = Sangat Puas)</h3>
            </div>
            <Datagrid isRowSelectable={false} bulkActionButtons={false}>
                {/* <TextField source="id" /> */}
                {/* <NumberField source="id_pengunjung" /> */}
                <ReferenceField label="Foto Pengunjung" source="id_pengunjung" reference="queue" link={false} >
                    {/* <TextField source="nama_kab" /> */}
                    <CustomImageField source="foto_pengunjung_path" label="Foto Pengunjung" width={120} marginTop={0} />
                </ReferenceField>
                {/* <TextField source="niplama_petugas" /> */}
                <ReferenceField label="Nama Petugas PST" source="niplama_petugas" reference="petugas_pst" link={false} >
                    <TextField source="nama" />
                </ReferenceField>
                <CustomNumberField source="p1" label="Petugas pelayanan merespon dengan baik" />
                <CustomNumberField source="p2" label="Kerapihan Petugas Pelayanan" />
                <CustomNumberField source="p3" label="Petugas Pelayanan Menerapkan Budaya Senyum" />
                <CustomNumberField source="p4" label="Petugas Pelayanan Menerapkan Budaya Sapa" />
                <CustomNumberField source="p5" label="Petugas Pelayanan Menerapkan Budaya Salam" />
                <CustomNumberField source="p6" label="Petugas Pelayanan Menerapkan Budaya Sopan" />
                <CustomNumberField source="p7" label="Petugas Pelayanan Menerapkan Budaya Santun" />
               
                <TextField source="saran" />
                <DateField source="created_at" label="Tanggal Layanan" locales="id-ID" />
            </Datagrid>

        </div>
    </List>
);